import React from 'react';
import PropTypes from 'prop-types';
import { htmlDecode } from '../../../utils/htmlDecoder';
import css from './Details.css';

export default class Details extends React.Component {
  render() {
    return (
      <div className={css['container']}>
        <label
          htmlFor="appointmentConfirmationDetailsTextbox">{`If you want, tell us a little bit about what's going on so we can help`}</label>
        <textarea value={htmlDecode(this.props.value)} onChange={this.props.onChange}
                  id="appointmentConfirmationDetailsTextbox"></textarea>
      </div>
    );
  }
}

Details.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
